// import { logger } from '@/helpers';
import { defineComponent, ref,  watch, onMounted } from "vue";

// import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ApiService } from "@/api/api";
import { gsap } from "gsap";
import { useGtag } from "vue-gtag-next";


export default defineComponent({
  // type inference enabled
  name: "ConsentCampaign",
  components: {},

  setup() {
    // const router = useRouter();
    const store = useStore();
    const { event } = useGtag()

    const checked = ref(false);
    const IsError = ref(false);
    const confirmConsent = ref<boolean>(true);

    const IsShowConsent = ref(true);

    watch(checked, () => {
      IsError.value = false;
    });

    const ShowPopupCookie = () => {
      store.dispatch("SetPopupCookie", true);
    };

    const SubmitConsent = async () => {
      // console.log(checked.value);
      localStorage.setItem("allow_cookie", "true");
      store.dispatch('SetBTStart',true)
      IsShowConsent.value= false;
      const RequestParam = {
        activity: "consent",
      };

      event('apirequest', { 'event_category' : 'consent',    })

      await ApiService.SaveUserActivity(RequestParam);

      // if (checked.value == true) {
      //   //
      //   if (localStorage.getItem("allow_cookie") != "true") {
      //     const RequestParam = {
      //       activity: "consent",
      //     };

      //     await ApiService.SaveUserActivity(RequestParam);
      //   }

      //   //
      //   localStorage.setItem("allow_cookie", "true");

      //   router.push("/play");
      // } else {
      //   IsError.value = true;
      //   localStorage.setItem("allow_cookie", "false");
      // }
    };

    const handleIsConsent = (status: boolean) => {
      confirmConsent.value = status;
    }

    const handleConsentConfirm = (status: boolean) => {
      confirmConsent.value = status;
      checked.value = true;

      setTimeout(() => {
        SubmitConsent()
      }, 500)
    }

    onMounted(() => {
      // consent animate
      gsap.fromTo('.ConsentCampaign', {alpha:0, y: 100}, {alpha: 1, y: 0, delay: 0.5, duration: 0.5})
    })

    return {
      checked,
      IsError,
      IsShowConsent,
      ShowPopupCookie,
      SubmitConsent,
      confirmConsent,
      handleIsConsent,
      handleConsentConfirm
    };
  },
});
